module.exports = __webpack_public_path__ + "static/buildBrand-37058be1a4c46de29cce42f3a72aada1.png";